import React from 'react'

const AntistaticWorkbench = () => {
    return (
        <div>
            <section class="inner-banner">
                <div class="thm-container">
                    <h2> Product Details </h2>
                    <div class="breadcumb">
                        <a href="/">ESD Lab Setup</a>
                        <i class="fa fa-angle-right"></i>
                        <span>Antistatic workbench</span>
                    </div>
                </div>
            </section>
            <div className='container py-4'>
                <div className='row d-flex' style={{ margin: "80px 0px" }}>
                    <div className='col-lg-6 col-md-6 col-sm-12 col-xs-12'>
                        <img src='/img/antistatic.png' width={400}></img>
                    </div>
                    <div className='col-lg-6 col-md-6 col-sm-12 col-xs-12'>
                        <h2 style={{ textDecoration: "underline" }}>Antistatic workbench:</h2>
                        <p className="mbot25">
                            <b style={{ textDecoration: "underline",marginRight:'5px' }}>Description:</b>
                            An antistatic workbench is a critical component
                            in an ESD (Electrostatic Discharge) lab, designed to prevent
                            static electricity buildup that can damage sensitive
                            electronic components. These workbenches are typically
                            constructed with materials that dissipate static charges and
                            include grounding points to ensure safe handling of
                            electronic devices. They provide a controlled environment to
                            protect electronic assemblies during testing and repair.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AntistaticWorkbench
